<template>
  <div class="login w-100 h-100 d-flex mt-5">
    <section class="bg-blur login auth col-12 mx-auto align-self-md-center col-md-7 col-xl-4 col-xxl-4">
      <div class="half-design row">
        <div class="col-12 form-block">
          <div class="logo col-auto p-0">
            <img src="@/assets/logo_full.svg" alt="logo" height="70px" class="mx-auto" />
          </div>

          <div class="col-12 col-md-10 mx-auto mt-3">

            <p class="text-center">

              Forgot password? No problem, enter your email and we will send you updated Password

            </p>

            <b-form @submit.prevent="onSubmit">

              <div class="mb-3 text-left">

                <label for="email" :class="emailState" class="mb-1">Please enter your email:</label>



                <b-form-input id="email" type="email" v-model="formFields.email" @input="validateEmail"
                  :class="emailState" autofocus></b-form-input>



                <b-form-invalid-feedback v-if="formErrors.email">{{

                  formErrors.email

                  }}</b-form-invalid-feedback>

              </div>

              <b-button type="submit" variant="primary" class="mb-3 w-100" :disabled="loader">

                <div class="spinner-border spinner-border-sm text-light" role="status" v-if="loader"></div>

                Submit

              </b-button>

              <p class="text-center">

                <router-link :to="{ name: 'Login' }">Back to Login</router-link>

              </p>

            </b-form>

          </div>
        </div>
      </div>
    </section>
  </div>
</template>


<script>
import { request } from "@/Util/Request"; // Assuming you have a request utility function
import { mapGetters } from 'vuex';
import { reactive } from 'vue';

export default {
  data() {
    return {
      formFields: reactive({
        email: '',
      }),
      formErrors: reactive({}),
    };
  },
  computed: {
    ...mapGetters(['loader']),
    emailState() {
      return this.formFields.email === undefined || this.formFields.email === ''
        ? ''
        : this.formErrors.email
          ? 'is-invalid'
          : 'is-valid';
    },
  },
  methods: {
    validateEmail() {
      if (!this.formFields.email || !/.+@.+\..+/.test(this.formFields.email)) {
        this.formErrors.email = 'Enter a valid email';
      } else {
        delete this.formErrors.email;
      }
    },
    async onSubmit() {
      delete this.formErrors.email;
      this.validateEmail();

      if (Object.keys(this.formErrors).length) return;

      try {
        this.loader = true;

        // API call to send the email for password reset
        const response = await request({
          method: 'post',
          url: 'auth/forgot-password',  // Endpoint for password reset request
          data: { email: this.formFields.email },
        });

        this.showToast();

        // Redirect to login page after 5 seconds
        setTimeout(() => {
          this.$router.push({ name: 'Login' });
        }, 5000);

      } catch (error) {
        this.formErrors.general = 'An error occurred. Please try again.';
        this.notifyError();
      } finally {
        this.loader = false;
      }
    },
    showToast() {
      const h = this.$createElement;
      const vNodesMsg = h('p', { class: ['text-center', 'mb-0'] }, [
        `Password Reset Link was successfully sent to your email`,
      ]);
      const vNodesTitle = h(
        'div',
        { class: ['d-flex', 'flex-grow-1', 'align-items-baseline', 'mr-2'] },
        [h('strong', { class: 'mr-2' }, 'Reset Link was sent')]
      );
      this.$bvToast.toast([vNodesMsg], {
        title: [vNodesTitle],
        solid: true,
        variant: 'success',
      });
    },
    notifyError() {
      this.$bvToast.toast('An error occurred, please try again!', {
        variant: 'danger',
        solid: true,
      });
    }
  },
};
</script>
